(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/betslip/assets/javascripts/betslip-sticky.js') >= 0) return;  svs.modules.push('/components/lb-ui/betslip/assets/javascripts/betslip-sticky.js');
"use strict";


const _React = React,
  useContext = _React.useContext,
  useRef = _React.useRef,
  useEffect = _React.useEffect;
const _svs$components$lbUi$ = svs.components.lbUi.betslip,
  BetslipContext = _svs$components$lbUi$.BetslipContext,
  useDisableOverflowX = _svs$components$lbUi$.useDisableOverflowX;
const format = svs.utils.format;
const ReactIcon = svs.ui.ReactIcon;
const detect = svs.core.detect;
const BetslipSticky = _ref => {
  let children = _ref.children;
  const _useContext = useContext(BetslipContext),
    price = _useContext.price,
    isPayable = _useContext.isPayable,
    isPayButtonVisible = _useContext.isPayButtonVisible,
    getScrollContainer = _useContext.getScrollContainer,
    stickyRef = _useContext.stickyRef,
    stickyPlaceholderRef = _useContext.stickyPlaceholderRef,
    payButtonRef = _useContext.payButtonRef;
  const priceClassNames = ['betslip-sticky-price'];
  if (isPayable) {
    priceClassNames.push('betslip-sticky-price-is-payable');
  }
  if (isPayButtonVisible) {
    priceClassNames.push('betslip-sticky-price-is-pay-button-visible');
  }
  const blinkRef = useRef();
  useEffect(() => {
    if (isPayable) {
      blinkRef.current.classList.add('betslip-blink-active');
    } else {
      blinkRef.current.classList.remove('betslip-blink-active');
    }
  }, [isPayable]);
  const priceValueClasses = ['betslip-price-value'];
  if (isPayable) {
    priceValueClasses.push('betslip-price-value-payable');
  }

  useDisableOverflowX();
  function onClickSticky() {
    const scrollContainer = getScrollContainer && getScrollContainer();
    if (scrollContainer) {
      const scrollTop = payButtonRef.current.parentElement.offsetTop - scrollContainer.offsetHeight + payButtonRef.current.parentElement.offsetHeight;
      $(scrollContainer).animate({
        scrollTop
      }, 400, 'swing');
    } else {
      $('html, body').animate({
        scrollTop: document.body.scrollHeight
      }, 400, 'swing');
    }
  }
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "betslip-sticky",
    onClick: onClickSticky,
    ref: stickyRef
  }, React.createElement("div", {
    className: "betslip-sticky-content"
  }, children), React.createElement("div", {
    className: priceClassNames.join(' ')
  }, React.createElement("div", {
    className: priceValueClasses.join(' ')
  }, format.Currency(price), ' ', "kr"), isPayable ? React.createElement(ReactIcon, {
    color: "fc-white",
    icon: "menu-down",
    size: "100"
  }) : null), React.createElement("div", {
    className: "betslip-blink",
    ref: blinkRef
  })), detect.browser.ie() ? React.createElement("div", {
    className: "betslip-sticky-placeholder",
    ref: stickyPlaceholderRef
  }) : null);
};
setGlobal('svs.components.lbUi.betslip.BetslipSticky', BetslipSticky);

 })(window);